exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../css-loader/dist/cjs.js!./widget.css"), "");
exports.i(require("-!../../../css-loader/dist/cjs.js!./commandpalette.css"), "");
exports.i(require("-!../../../css-loader/dist/cjs.js!./dockpanel.css"), "");
exports.i(require("-!../../../css-loader/dist/cjs.js!./menu.css"), "");
exports.i(require("-!../../../css-loader/dist/cjs.js!./menubar.css"), "");
exports.i(require("-!../../../css-loader/dist/cjs.js!./scrollbar.css"), "");
exports.i(require("-!../../../css-loader/dist/cjs.js!./splitpanel.css"), "");
exports.i(require("-!../../../css-loader/dist/cjs.js!./tabbar.css"), "");
exports.i(require("-!../../../css-loader/dist/cjs.js!./tabpanel.css"), "");
// Module
exports.push([module.id, "/*-----------------------------------------------------------------------------\r\n| Copyright (c) 2014-2017, PhosphorJS Contributors\r\n|\r\n| Distributed under the terms of the BSD 3-Clause License.\r\n|\r\n| The full license is in the file LICENSE, distributed with this software.\r\n|----------------------------------------------------------------------------*/\r\n", ""]);
